import * as yup from 'yup';

export const ForgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .lowercase()
    .email('正しいメールアドレスを入力してください。')
    .required('メールアドレスを入力してください'),
});
